import { Breadcrumb } from 'antd';
import * as React from 'react';
import { Link, useHistory } from 'react-router-dom';
import { ReactComponent as BackIcon } from '../../../../assets/images/ic_back.svg';
import { ReactComponent as ArrowIcon } from '../../../../assets/icons/ic_chevron_right.svg';
import './MobileBreadCrumb.scss';

const maps = {
  dashboard: 'Tổng quan',
  banner: 'Banner',
  'text-link': 'Text Links',
  promotion: 'Mã ưu đãi',
  'co-branding': 'Co-branding',
  'thu-nhap': 'Thu nhập',
  my_account: 'Tài khoản của tôi',
  'help/list': 'Hỗ trợ',
};

const specialPath = ['help/list'];

function checkSpecialPath() {
  for (let i = 0; i < specialPath.length; i++) {
    const p = specialPath[i];
    if (window.location.pathname.indexOf(p) > -1) {
      return p;
    }
  }
  return false;
}

const MobileBreadCrumb = (props) => {
  const { hideBackButton } = props;
  const history = useHistory();

  let paths = window.location.pathname.split('/').filter((i) => i);
  let breadcrumbData = [];
  const specialPath = checkSpecialPath();
  if (specialPath) {
    breadcrumbData.push({
      text: maps[specialPath] || specialPath,
      link: null,
    });
  } else {
    let path = '';
    for (let i = 0; i < paths.length; i++) {
      const p = paths[i];
      path += `/${p}`;
      breadcrumbData.push({
        text: maps[p] || p,
        link: i < paths.length - 1 ? path : null,
      });
    }
  }

  const handleBack = () => {
    if (breadcrumbData?.length > 1) {
      history.push(breadcrumbData[breadcrumbData.length - 2].link);
    } else {
      history.push('/');
    }
  };

  return (
    <div className='mobile-bread-crumb'>
      {!hideBackButton && (
        <span onClick={handleBack}>
          <BackIcon className='back-icon' />
        </span>
      )}
      <Breadcrumb separator={<ArrowIcon />}>
        <Breadcrumb.Item>
          <Link to='/'>Trang chủ</Link>
        </Breadcrumb.Item>
        {breadcrumbData.map((p) => {
          return (
            <Breadcrumb.Item key={p.text}>
              {p.link ? <Link to={p.link}>{p.text}</Link> : p.text}
            </Breadcrumb.Item>
          );
        })}
      </Breadcrumb>
    </div>
  );
};

export default MobileBreadCrumb;
